// extracted by mini-css-extract-plugin
export var badges = "profile-recent-badges-module--badges--fcc34";
export var text = "profile-recent-badges-module--text--cbe22";
export var textContainer = "profile-recent-badges-module--textContainer--21f35";
export var title = "profile-recent-badges-module--title--3f317";
export var viewAll = "profile-recent-badges-module--viewAll--ed30f";